import React from "react";
import { useDropzone } from "react-dropzone";

import styled from "styled-components";
import strings from "../../../../res/strings";

const getColor = (props) => {
  if (props.isDragAccept) {
    return "#00e676";
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isDragActive) {
    return "#2196f3";
  }
  return "#eeeeee";
};

const DropContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #999999;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;

const ThumbsContainer = styled.aside`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 16px;
`;

const Thumb = styled.div`
  display: inline-flex;
  border-radius: 2px;
  border: 1px solid #eaeaea;
  margin-bottom: 8px;
  margin-right: 8px;
  width: 100px;
  height: 100px;
  padding: 4px;
  box-sizing: border-box;
`;

const ThumbInner = styled.div`
  display: flex;
  min-width: 0px;
  overflow: hidden;
`;

const Image = styled.img`
  display: block;
  width: auto;
  height: 100%;
`;

const ServiceOuterDropContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #ffffff;
  color: #999999;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;
const ServiceImageDropContainer = styled.div``;
const ServiceDropImage = styled.img`
  max-height: 150px;
`;

const ImageSelector = (props) => {
  const handleImageSelected = (acceptedImages) => {
    if (acceptedImages.length > 0) {
      props.setSelectedImages(
        acceptedImages.map((image) =>
          Object.assign(image, {
            preview: URL.createObjectURL(image),
          })
        )
      );
    }
  };

  const handleRemoveImage = (removeIndex) => {
    const newSelectedImages = [];
    props.selectedImages.forEach((image, index) => {
      if (index !== removeIndex) {
        newSelectedImages.push(image);
      }
    });

    props.setSelectedImages(newSelectedImages);
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop: handleImageSelected,
    accept: "image/*",
    maxFiles: props.maxFiles,
  });

  const selectedImageItems = props.selectedImages.map((image, index) => {
    return (
      <Thumb
        key={image.name}
        onClick={() => {
          handleRemoveImage(index);
        }}
      >
        <ThumbInner>
          <Image src={image.preview} />
        </ThumbInner>
      </Thumb>
    );
  });

  if (props.type === "SERVICE_IMAGE") {
    let dropContainer = (
      <ServiceImageDropContainer>
        <ServiceDropImage src={props.image} />
      </ServiceImageDropContainer>
    );
    if (props.selectedImages.length > 0) {
      const selectedImage = props.selectedImages[0];

      dropContainer = (
        <ServiceDropImage
          src={selectedImage.preview}
          onClick={() => {
            props.setSelectedImages([]);
          }}
        />
      );
    }

    const style = {
      background: "#e7e7e7",
      borderColor: "#bababa",
    };

    return (
      <>
        <ServiceOuterDropContainer
          {...getRootProps({
            isDragActive,
            isDragAccept,
            isDragReject,
            style,
          })}
        >
          <input {...getInputProps()} />
          {dropContainer}
        </ServiceOuterDropContainer>
      </>
    );
  }

  const style = {
    background: "#e7e7e7",
    borderColor: "#bababa",
  };

  return (
    <>
      <DropContainer
        {...getRootProps({ isDragActive, isDragAccept, isDragReject, style })}
      >
        <input {...getInputProps()} />
        <p>
          {props.placeholder ??
            strings.lib_file_instructions_image_upload_single}
        </p>
      </DropContainer>
      <ThumbsContainer>{selectedImageItems}</ThumbsContainer>
    </>
  );
};

export default ImageSelector;
